<template>
  <div class="mobile-layout">

    <slot />

    <MobileCart :current-page="$route.name" />

    <ApiErrors />

    <MobileModal v-model="checkoutModal"
                 :close-on-overlay="true"
                 center-content
    >
      <MobileSimpleModalContainer title="Checkout">
        <CheckoutModal :show-guest-button="false"
                       @create-account="handleCreateAccount"
                       @guest-checkout="handleGuestCheckout"
                       @sign-in="handleSignIn"/>
      </MobileSimpleModalContainer>
    </MobileModal>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileCart from '@/apps/mobile/components/MobileCart';
import ApiErrors from '@/components/ApiErrors';
import { Action, Getter, Mutation } from 'vuex-class';
import { AUTH_MODAL, PUSH_DEVICE_FCM_TOKEN } from '@/apps/auth/store/types';
import CommonModal from '@/apps/shared/components/CommonModal';
import CheckoutModal from '@/components/CheckoutModal';
import { MODAL_CLOSE_ALL, MODAL_UPDATE } from '@/apps/core/store/types';
import MobileModal from '@/apps/mobile/components/MobileModal';
import MobileSimpleModalContainer from '@/apps/mobile/components/MobileSimpleModalContainer';
import { CART_COLLAPSE, HIDE_CHECKOUT_DIALOG } from '@/apps/cart/store/types';
import { PushNotifications } from '@capacitor/push-notifications';
/**
 * Layout for mobile devices. Could be dynamically selected on the default
 * layout component.
 */
@Component({
  components: {
    MobileSimpleModalContainer,
    MobileModal,
    CheckoutModal,
    CommonModal,
    ApiErrors,
    MobileCart,
  },
})
export default class MobileLayout extends Vue {
  @Getter modalInfo;
  @Getter showCheckoutModal;
  @Action(MODAL_UPDATE) modalUpdate;
  @Mutation(AUTH_MODAL) setAuthModal;
  @Action(MODAL_CLOSE_ALL) modalCloseAll;
  @Action(HIDE_CHECKOUT_DIALOG) hideCheckoutModal;
  @Action(CART_COLLAPSE) collapseCart;
  @Action(PUSH_DEVICE_FCM_TOKEN) pushFcmToken;

  get checkoutModal() {
    return this.showCheckoutModal;
  }

  set checkoutModal(value) {
    if (!value) {
      this.hideCheckoutModal();
    }
  }

  /**
   * Event handler for "createAccount"
   */
  handleCreateAccount() {
    this.collapseCart(true);
    this.hideCheckoutModal(true);
    this.$router.push({ name: 'join-sign-in', query: { checkoutAfterLogin: true } });
  }

  /**
   * Event handler for "signIn"
   */
  handleSignIn() {
    this.collapseCart(true);
    this.hideCheckoutModal(true);
    this.$router.push({ name: 'claim-account', query: { checkoutAfterLogin: true } });
  }

  /**
   * Event handler for "guestCheckout"
   */
  handleGuestCheckout() {
    this.collapseCart(true);
    this.hideCheckoutModal(true);
    this.$router.push({ name: 'guest-checkout' });
  }

  mounted() {
    this.initializePushNotifications();
  }

  unmounted() {
    PushNotifications.removeAllListeners();
  }

  initializePushNotifications() {
    this.requestPushNotificationsPermissions();
    PushNotifications.addListener('registration', token => this.pushFcmToken({ token: token.value }));
  }

  requestPushNotificationsPermissions() {
    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting.
    PushNotifications.requestPermissions()
      // On iOS devices, sometimes `requestPermissions` return denied regardless of the user's choice.
      // So we should double-check permissions to make sure about actual permission status.
      .then(() => PushNotifications.checkPermissions())
      .then(permissionStatus => this.registerPushNotificationsIfGranted(permissionStatus.receive));
  }

  registerPushNotificationsIfGranted(permissionState) {
    if (permissionState === 'granted') {
      // Register with Apple / Google to receive push via APNS/FCM
      PushNotifications.register();
    }
  }
}
</script>

<style lang="scss">
  /** Global style import **/
  @import '~@/style/global-mobile.scss';
</style>

<style lang="scss" scoped>
@import '~@/style/variables.scss';

.mobile-layout {
  flex: 100%;
  min-height: 1px;
  background-color: $mobile-bg-color;
}
</style>



// WEBPACK FOOTER //
// src/layouts/MobileLayout.vue